import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-onboardfields-popup',
  templateUrl: './onboardfields-popup.component.html',
  styleUrls: ['./onboardfields-popup.component.scss']
})
export class OnboardfieldsPopupComponent {
  consumptionForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<OnboardfieldsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.consumptionForm = this.fb.group({
      loadingFO: [''],
      loadingMGO: [''],

      dischargeFO: [''],
      dischargeMGO: [''],

      usPortFO: [''],
      usPortMGO: [''],

      idleFO: [''],
      idleMGO: [''],

      harbourFO: [''],
      harbourMGO: [''],

      tankFO: [''],
      tankMGO: [''],

      inertingFO: [''],
      inertingMGO: [''],

      cowFO: [''],
      cowMGO: [''],

      heatMaintainFO: [''],
      heatMaintainMGO: [''],

      heatRaiseFO: [''],
      heatRaiseMGO: ['']
    });

    if (this.data) {
      this.consumptionForm.patchValue(this.data);
    }
  }

  // optional old method kept
  selectOption(type: 'csv' | 'excel') {
    this.dialogRef.close(type);
  }

  saveConsumption() {
    this.dialogRef.close(this.consumptionForm.value);
  }

  closePopup() {
    this.dialogRef.close();
  }
}